import React, { useEffect, useState } from "react"
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Box, Skeleton, Typography } from "@mui/material";
import { RmDashBoardGraph, RmDashboardType, filterType } from "../../../redux-store/types/api-types";
import CircleIcon from '@mui/icons-material/Circle';
import CustomDropdown from "../../../lib/formik/CustomDropdown";
import { FilterSkeleton } from "./CustomePieChart";
import { getChartA11yOptions } from "../../../utils/highchartsAccessibility";

interface Props {
    data?: any;
}


export default function CardChart(props: Props): JSX.Element {

    const { data } = props
    // console.log('data', data)

    const a11y = getChartA11yOptions({
        altText: 'Summary trend column chart',
        description: 'Compact column chart visualizing the recent trend of values for this card.',
    });

    const option = {
        chart: {
            type: 'column',
            description: a11y.chartDescription,
        },
        title: a11y.title,
        accessibility: a11y.accessibility,
        subtitle: {
            text: ''
        },
        xAxis: {
            type: 'category',
            lineColor: 'transparent',
            labels: {
                // autoRotation: [-45, -90],
                enabled: false,
                // style: {
                //     fontSize: '13px',
                //     fontFamily: 'Verdana, sans-serif'
                // }
            },

        },
        yAxis: {
            min: 0,
            labels: {
                enabled: false
            },
            title: {
                text: ''
            }
        },
        legend: {
            enabled: false
        },
        tooltip: {
            pointFormat: '<b>{point.y}</b>',
            enabled: false,
        },
        exporting: {
            enabled: false
        },
        credits: {
            enabled: false
        },
        series: [{
            name: 'Populationx',
            colors: [
                // "e9f4ff"
                "#0ECB81", "#F14366"
            ],
            // '#F14366', '#0ECB81', 
            showInLegend: false,
            borderRadius: 2,
            pointWidth: 5,
            pointPadding: 0,
            colorByPoint: true,
            groupPadding: 0,
            data: data,
            // data: [
            //     ['Tokyo', 37.33],
            //     ['Delhi', 31.18],
            //     ['Shanghai', 27.79],
            //     ['Sao Paulo', 22.23],
            //     ['Mexico City', 21.91],
            //     ['Dhaka', 21.74],
            //     ['Cairo', 21.32],
            //     ['Beijing', 20.89],
            //     ['Mumbai', 20.67],
            //     ['Osaka', 40.11],
            //     ['Karachi', 16.45],
            //     ['Chongqing', 16.38],
            //     ['Istanbul', 15.41],
            // ],
            dataLabels: {
                enabled: false,
                rotation: -90,
                color: '#FFFFFF',
                inside: true,
                verticalAlign: 'top',
                format: '{point.y:.1f}',
                y: 10,
                // style: {
                //     fontSize: '13px',
                //     fontFamily: 'Verdana, sans-serif'
                // }
            }
        }]
    }

    return (

        <>
            {data.length > 0 &&
                <HighchartsReact
                    highcharts={Highcharts}
                    options={{ ...option }}
                    containerProps={{ style: { height: 70, width: 70, padding: 0, margin: 0 } }}
                    background="transparent" />}
        </>
    )
}
